import React from 'react';
import {useSelector} from "react-redux";
import RenderedHtmlContent from 'src/shared/virtual_congress/components/rendered_html_content'
import {useVideoRoomEventFor} from "./utils";

export default function Agenda({videoRoom, agendaOptions}) {
    const tagOwner = useSelector(state => state.tagOwner)
    const videoRoomEvent = useVideoRoomEventFor(videoRoom, videoRoom.take_agenda_from, agendaOptions?.overrideEvent)

    return <div className="videoroom-agenda">
        <RenderedHtmlContent
          html={videoRoomEvent.video_description?.replace(/@tag_owner_id@/g, tagOwner.id)}
          placeholders={{videoRoom: videoRoom, tagOwner: tagOwner}}
        />
    </div>
}
